import './index.css';

import { Outlet } from 'react-router-dom';
import { SWRConfig } from 'swr';

import { AuthenticationLayer } from '@/components/shared/components/AuthenticationLayer/AuthenticationLayer';
import { DevelopOptionsPanel } from '@/components/shared/components/DevelopOptionsPanel/DevelopOptionsPanel';
import ErrorBoundary from '@/components/shared/components/ErrorBoundary/types/ErrorBoundary';
import { NotificationManager } from '@/components/shared/components/NotificationManager';
import { ThemeManager } from '@/components/shared/components/ThemeManager/ThemeManager';
import { Wrapper } from '@/components/shared/components/Wrapper';
import { ApplicationContextProvider } from '@/contexts/ApplicationContext/ApplicationContext';
import { ConfigContextProvider } from '@/contexts/ConfigContext/ConfigContext';
import { NotificationsContextProvider } from '@/contexts/NotificationsContext/NotificationsContext';
import { OperationsContextProvider } from '@/contexts/OperationsContext/OperationsContext';
import { PageContextProvider } from '@/contexts/PageContext/PageContext';
import { UserContextProvider } from '@/contexts/UserContext/UserContext';

export function App(props) {
  const { currentPath } = props;

  return (
    <div className="App notranslate">
      <UserContextProvider>
        <ConfigContextProvider>
          <PageContextProvider>
            <OperationsContextProvider>
              <ApplicationContextProvider>
                <NotificationsContextProvider>
                  <ThemeManager>
                    <ErrorBoundary>
                      <SWRConfig
                        value={{
                          revalidateOnFocus: false,
                          shouldRetryOnError: false,
                        }}
                      >
                        <Wrapper>
                          <NotificationManager />
                          <AuthenticationLayer currentPath={currentPath}>
                            <DevelopOptionsPanel />
                            <Outlet />
                          </AuthenticationLayer>
                        </Wrapper>
                      </SWRConfig>
                    </ErrorBoundary>
                  </ThemeManager>
                </NotificationsContextProvider>
              </ApplicationContextProvider>
            </OperationsContextProvider>
          </PageContextProvider>
        </ConfigContextProvider>
      </UserContextProvider>
      <div id="nemuru-order-management"></div>
    </div>
  );
}
